let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9OAhR")).then(() => parcelRequire('nKO3E'));